import React, { useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ToastProvider: React.FC = () => {
  useEffect(() => {
    const handleShowToast = (event: Event) => {
      const customEvent = event as CustomEvent<{ message: string; type?: 'info' | 'success' | 'error' | 'warning' }>;
      const { message, type = 'info' } = customEvent.detail;

      // Display the toast
      toast[type](message);
    };

    window.addEventListener('show-toast', handleShowToast);

    return () => {
      window.removeEventListener('show-toast', handleShowToast);
    };
  }, []);

  return (
    <ToastContainer
      autoClose={300}
      theme="colored"
      toastClassName="app-toast"
    />
  );
};

export default ToastProvider;